import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';

import './App.css';
import Login from './components/Guest/Login/Login';
import Dashboard from './components/Auth/Dashboard/Dashboard';
import Profile from './components/Auth/Profile/Profile';
import Register from './components/Guest/Register/Register';
import ForgottenPassword from './components/Guest/Forgotten-Password/Forgotten-Password';
import ResetPassword from './components/Guest/Reset-Password/Reset-Password';
import DeleteAccount from './components/Auth/Delete-Account/Delete-Account';

import {useToken} from './utils/useToken';
import {createAuthFetch} from "./utils/authFetch";

import CreateType from './components/Auth/Create-Type/Create-Type';
import Type from './components/Auth/Type/Type';
import TypeDate from './components/Auth/Type-Date/Type-Date';
import ReadingEdit from './components/Auth/Reading-Edit/Reading-Edit';
import Readings from './components/Auth/Readings/Readings';
import NavDropdown from './components/Auth/Nav-Dropdown/Nav-Dropdown';


function App() {

    const {accessToken, setTokens} = useToken();
    const authFetch = createAuthFetch(accessToken, setTokens);

    if (!accessToken) {
        // Guest routes
        return (
            <div className="wrapper">
                <h1>LogMe</h1>
                <div className="topnav loginnav">
                    <a href="/">Login</a>
                    <a href="/register">Register</a>
                    <a href="/forgotten-password">Forgotten Password</a>
                </div>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Login setTokens={setTokens} authFetch={authFetch}/>}/>
                        <Route path="/register" element={<Register setAccessToken={setTokens}/>}/>
                        <Route path="/forgotten-password" element={<ForgottenPassword/>}/>
                        <Route path="/reset-password" element={<ResetPassword/>}/>
                    </Routes>
                </BrowserRouter>
            </div>
        );
    }

    // Authorized routes
    return (
        <div className="wrapper">
            <h1>LogMe</h1>

            <BrowserRouter>
                <NavDropdown authFetch={authFetch}/>
                <Routes>
                    <Route path="/" element={<Dashboard authFetch={authFetch}/>}/>
                    <Route path="/create-type" element={<CreateType authFetch={authFetch}/>}/>
                    <Route path="/type/:typeId/date/:date" element={<TypeDate authFetch={authFetch}/>}/>
                    <Route path="/type/:typeId" element={<Type authFetch={authFetch}/>}/>
                    <Route path="/edit-reading/:readingId" element={<ReadingEdit authFetch={authFetch}/>}/>
                    <Route path="/profile" element={<Profile authFetch={authFetch}/>}/>
                    <Route path="/delete-account" element={<DeleteAccount authFetch={authFetch}/>}/>
                    <Route path="/readings" element={<Readings authFetch={authFetch}/>}/>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;